import { jwtDecode } from 'jwt-decode';
import { create } from 'zustand';

// Define the state and actions types
type UserStoreState = {
  isAuthenticated: boolean;
  userRole: string | undefined;
  setUserRole: (session: string) => void;
  setIsAuthenticated: (authenticated: boolean) => void;
  depositAddresses: Array<string>;
  setDepositAddresses: (addresses: Array<string>) => void;
};

// Create the store
const useUserStore = create<UserStoreState>((set) => ({
  isAuthenticated: false, // Initial authentication status
  userRole: undefined, // Initial user role
  depositAddresses: [],
  setUserRole: (session: string) => {
    if (session) {
      const token: any = jwtDecode(session);
      set({ userRole: token?.explorerUserRole || 'USER' });
    } else {
      set({ userRole: undefined });
    }
  }, // Action to update user role
  setDepositAddresses: (addresses: Array<string>) => {
    set({ depositAddresses: addresses });
  }, // Action to update authentication status
  setIsAuthenticated: (authenticated) => {
    set({ isAuthenticated: authenticated });
  }, // Action to update authentication status
}));

export { useUserStore };
